import { Grid, Skeleton } from '@mui/material';
import WidgetCard from '../WidgetCard/WidgetCard';

const DetailSectionsLoading = ({ widgetCount = 1, itemCountArr = [10] }) => (
  <Grid container spacing={3}>
    {Array.from(Array(widgetCount).keys()).map((widgetIndex) => {
      const itemCount = itemCountArr[widgetIndex] ?? 12;
      return (
        <Grid key={`WidgetLoading-${widgetIndex}`} item xs={12}>
          <WidgetCard
            elevation={6}
            body={
              <Grid container spacing={1}>
                {Array.from(Array(itemCount).keys()).map((x) => (
                  <Grid
                    item
                    key={`detailRow-${x}-loading`}
                    xs={12}
                    md={6}
                    lg={4}
                    xl={3}
                  >
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      height={32}
                      sx={{ borderRadius: '4px' }}
                    />
                  </Grid>
                ))}
              </Grid>
            }
          />
        </Grid>
      );
    })}
  </Grid>
);

export default DetailSectionsLoading;
